export const handleSearch = (data, searchTerm) => {
  return data.filter(item =>
    (item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase())) 
    ||
    (item.firstName && item.email && item.lastName && item.firstName.toLowerCase().includes(searchTerm.toLowerCase()) || item.email.toLowerCase().includes(searchTerm.toLowerCase()) || item.lastName.toLowerCase().includes(searchTerm.toLowerCase())  )
  );
};
